import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: auto;

  .span-register {
    width: 450px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    margin-bottom: 30px;

    @media(max-width: 800px) {
      font-size: 16px;
      text-align: center;
      width: 350px;
    }
  }
`;

export const Title = styled.div`
  text-align: center;
  font-size: 28px;
  margin-top: 20px;
  font-weight: bold;
`;

export const ContainerRegister = styled.div`
  width: 700px;
  min-height: 300px;
  max-height: auto;
  display: flex;
  justify-content: center;
  margin: auto;

  @media(max-width: 800px) {
    width: 100vw;
  }

  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    content: none;
  }

  .label {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    font-weight: bold;

    @media(max-width: 800px) {
      width: 90vw;
      margin-left: 20px;
      align-items: center;
      flex-direction: row;
    }
  }

  .input {
    width: 580px;
    height: 25px;
    color: #808080;
    padding: 0;
    border: none;
    border-bottom: 1px solid;
    border-radius: 0px;
    border-color: #3C3C3B;

    @media(max-width: 800px) {
      width: 90vw;
    }
  }

  .input:focus {
    border-right-width: 1px !important;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .container-submit {
    width: 100%;
    display: flex;
    height: 60px;
    margin-bottom: 60px;
    flex-direction: column;
    align-items: center;

    @media(max-width: 800px) {
      width: 100vw;
      margin: auto;
      margin-bottom: 70px;
    }
  }

  .btn-send {
    font-size: 2%;
    width: 124px;
    height: 35px;
    border: none;
    background-color: black;
    color: white;
    cursor: pointer;
    margin: auto;
    letter-spacing: 1px;
      :hover{
        background-color: white;
        color: black;
        border: 1px solid black;
      }
      :disabled{
        background-color: #D6D6D6;
        color: black;
        cursor: not-allowed;
      }

      @media(max-width: 800px) {
        width: 90vw;
        margin: auto;
        height: 45px;
        margin-top: 30px;
      }
  }
`;

export const Terms = styled.div`
  width: 650px;
  margin: auto;

  @media(max-width: 800px) {
    width: 100vw;
  }
`

export const Authorizations = styled.div`
  width: inherit;
  height: auto;
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-bottom: 20px;

  @media(max-width: 800px) {
    width: 90vw;
    margin-left: 20px;
  }

  @media(min-width: 1920px) {
    margin: auto;
  }

  input:focus, input:focus-visible {
    border: 0;
    outline: none;
  }

  input[type='checkbox']::before {
    content: ' ';
    width: 25px;
    height: 25px;
    position: absolute;
    background-color: #ECECEC;
    border-radius: 30px;
    border: 2px solid black;
    margin: -6px 0 0 -5px;
  }
input[type='checkbox']:checked::after {
  content: '';
  border-color: black;
  border-style: solid;
  border-width: 11px 11px 11px 11px;
  position: absolute;
  margin-left: -3px;
  margin-top: -4px;
  border-radius: 50%;
  display: inline-block;
}

  span {
    margin-left: 25px;
    width: 100%;
    font-size: 15px;
    font-weight: bold;
  }

  .required-term::after{
    content: "*";
    color: red;
  }

  .container-checkbox {
    display: flex;
    margin-top: 20px;
    width: 100%;
    height: auto;
    margin-bottom: 10px;
    font-size: 15px;
    align-items: center;

    @media(max-width: 800px) {
      max-width: 100vw; 
    }
  }

  p {
    color: red;
    font-size: 15px;
  }
`

export const ModalTerm = styled.div`
  width: inherit;
  height: 40px;
  margin: auto;
  cursor: pointer;

  @media(max-width: 800px) {
    height: 80px;
    width: 85vw;
    margin-top: 20px;
  }
`